
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"22","cy":"22","r":"16","fill":"#F2F3F5"}}),_c('path',{attrs:{"d":"M20.311 17.965v6.877c0 .95.769 1.723 1.72 1.726v0a1.727 1.727 0 001.734-1.726v-6.017M26.773 25.702v-7.78M17.227 25.702v-6.018M20.307 17.965v-.43c0-1.662 1.447-3.009 3.233-3.009v0c1.785 0 3.233 1.347 3.233 3.009v.43","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17.227 25.702v0C17.227 28.075 19.364 30 22 30v0c2.635 0 4.773-1.925 4.773-4.298v0","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    